import * as angular from "angular";
import {IController} from "angular";
import {DraftJobChangesSyncState} from "../../types/draft-job-changes-sync-state.enum";

export class PlanningDraftJobChangesStatusCtrl implements IController {
  draft: any;

  public colorMap: any;
  public readonly syncStates = DraftJobChangesSyncState;

  /* @ngInject */
  constructor(private planningConstants) {
  }

  $onInit() {
    this.colorMap = this.planningConstants.draftJobChangesSyncStateColorMap;
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftJobChangesStatus', {
    bindings: {
      draft: '<'
    },
    template: require('./planning-draft-job-changes-status.html').default,
    controller: PlanningDraftJobChangesStatusCtrl
  });
